<template>
  <div class="tournament">
    <loading-state :state="state"></loading-state>
    <div v-if="tournament">
      <h2>{{tournament.name}}</h2>

      <section v-if="tournament.pointsTable.rounds">
        <h3>Points Table</h3>
        <div class="sub-content">
          <div class="item compact">
            <div>
              <div v-for="round in tournament.pointsTable.rounds" :key="round.key">
                <h4 class="heading" v-if="tournament.pointsTable.rounds.length > 1">{{round.name}}</h4>
                <span class="tag size-1-3 tableview" v-for="group in round.groups" :key="group.key">
                  <h4 class="table-heading">{{group.name}}</h4>
                  <table>
                    <thead>
                      <td>T</td>
                      <td>P</td>
                      <td>Res</td>
                      <td>Goals</td>
                      <td>GD</td>
                      <td>Pts</td>
                    </thead>
                    <tbody>
                      <tr v-for="standing in group.standings" :key="standing.$index">
                        <td>
                          <router-link
                            class="clean"
                            :to="{name:'tournamentTeam', params:{key:tournamentKey, teamkey:standing.team}}">
                            {{tournament.teams[standing.team].code}}</router-link>
                        </td>
                        <td>{{standing.matches_played}}</td>
                        <td>{{standing.matches_won}}:{{standing.matches_lost}}:{{standing.matches_drawn}}</td>
                        <td>{{standing.goals_for}}:{{standing.goals_against}}</td>
                        <td>{{standing.goal_difference}}</td>
                        <td>{{standing.points}}</td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section v-if="tournament.pointsTable.standings">
        <h3>Standings</h3>
        <div class="sub-content">
          <div class="item compact">
            <div>
              <span class="tag tableview">
                <table class="expanded">
                  <thead>
                    <td>Team</td>
                    <td>Played</td>
                    <td>Won</td>
                    <td>Draw</td>
                    <td>Lost</td>
                    <td>Goals</td>
                    <td>GD</td>
                    <td>Points</td>
                  </thead>
                  <tbody>
                    <tr v-for="standing in tournament.pointsTable.standings" :key="standing.$index">
                      <td>
                        <router-link
                          class="clean"
                          :to="{name:'tournamentTeam', params:{key:tournamentKey, teamkey:standing.team}}">
                          {{tournament.teams[standing.team].name}}</router-link>
                      </td>
                      <td>{{standing.matches_played}}</td>
                      <td>{{standing.matches_won}}</td>
                      <td>{{standing.matches_drawn}}</td>
                      <td>{{standing.matches_lost}}</td>
                      <td>{{standing.goals_for}}:{{standing.goals_against}}</td>
                      <td>{{standing.goal_difference}}</td>
                      <td>{{standing.points}}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h3>Player Stats</h3>
        <div class="sub-content">
          <div class="item compact">
            <div>
              <span class="tag size-1-3 tableview" v-for="name in playerStatsNames" :key="name.key">
                <h4 class="table-heading">{{name.name}}</h4>
                <table>
                  <tbody>
                    <tr v-for="item in tournament.stats.player[name.key]" :key="item.$index">
                      <td>
                        <router-link
                          class="clean"
                          :to="{name:'tournamentPlayer', params:{key:tournamentKey, playerkey:item.player.key}}">
                          {{item.player.name}}</router-link>
                      </td>
                      <td>{{item.value}}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h3>Team Stats</h3>
        <div class="sub-content">
          <div class="item compact">
            <div>
              <span class="tag size-1-3 tableview" v-for="name in teamStatsNames" :key="name.key">
                <h4 class="table-heading">{{name.name}}</h4>
                <table>
                  <tbody>
                    <tr v-for="item in tournament.stats.team[name.key]" :key="item.$index">
                      <td>
                          <router-link
                            class="clean"
                            :to="{name:'tournamentTeam', params:{key:tournamentKey, teamkey:item.team.key}}">
                            {{item.team.name}}</router-link>
                      </td>
                      <td>{{item.value}}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section v-if="tournament.pointing_system == 'tournament'">
        <h3>Match days</h3>
        <div class="sub-content">
          <div class="item compact">
            <div>
              <span class="tag" v-for="round in tournament.rounds" :key="round.key">
                <router-link class="clean" :to="{name:'tournamentRound', params:{key:tournament.key, roundkey:round.key}}">{{round.name}}</router-link>
              </span>
            </div>
          </div>
        </div>
      </section>
      <section v-else>
        <h3>Rounds</h3>
        <div class="sub-content">
          <div class="item compact link" v-for="round in tournament.rounds" :key="round.key">
            <div>
              <router-link class="clean" :to="{name:'tournamentRound', params:{key:tournament.key, roundkey:round.key}}">{{round.name}}</router-link>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h3>Teams</h3>
        <div class="sub-content">
          <div class="item compact link" v-for="team in tournament.teams" :key="team.key">
            <div>
              <router-link
              class="clean"
              :to="{name:'tournamentTeam', params:{key:tournament.key, teamkey:team.key}}">
              {{team.name}} ({{team.code}})</router-link>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>
<script>
import { FootballTournament } from '@/models/tournament'
import { DataState, AppState } from '@/state'
import Utils from '@/utils'

export default {
  name: 'tournament',
  data () {
    return {
      tournamentKey: this.$route.params.key,
      tournament: null,
      playerStatsNames: [],
      teamStatsNames: [],
      playerStatsDefaultNames: [
        { name: 'Goals', key: 'most_goals' },
        { name: 'Clean Sheet', key: 'most_clean_sheets' },
        { name: 'Most Offsides', key: 'most_offsides' },
        { name: 'Yellow Cards', key: 'most_yellow_cards' },
        { name: 'Red Cards', key: 'most_red_cards' },
        { name: 'Penalty Goals', key: 'most_penalty_goals' }
      ],
      teamStatsDefaultNames: [
        { name: 'Won', key: 'most_won' },
        { name: 'Defeated', key: 'most_defeated' },
        { name: 'Goals', key: 'most_goals' },
        { name: 'Clean Sheet', key: 'most_clean_sheets' },
        { name: 'Most Offsides', key: 'most_offsides' },
        { name: 'Yellow Cards', key: 'most_yellow_cards' },
        { name: 'Red Cards', key: 'most_red_cards' },
        { name: 'Penalty Goals', key: 'most_penalty_goals' }
      ],
      state: DataState.newLoading()
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.key !== from.params.key) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  methods: {
    onViewOpenned () {
      this.tournamentKey = this.$route.params.key
      const newTitle = 'loading...'
      AppState.updateActivePage(`tournament_${this.tournamentKey}`)
      AppState.updateTitles(newTitle, newTitle)

      FootballTournament.fetch(this.tournamentKey).then(tournament => {
        const newTitle = tournament.name
        AppState.updateTitles(newTitle, newTitle)
        this.tournament = tournament
        this.playerStatsNames = this.buildNameKeys(this.playerStatsDefaultNames, this.tournament.stats.player)
        this.teamStatsNames = this.buildNameKeys(this.teamStatsDefaultNames, this.tournament.stats.team)
        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },
    buildNameKeys (defaults, raw) {
      let nameKeys = []
      let names = []
      defaults.forEach((name) => {
        nameKeys.push(name.key)
        names.push(name)
      })

      Object.keys(raw).forEach((key) => {
        if (nameKeys.indexOf(key) == -1) {
          const name = Utils.capitalise(key)
          nameKeys.push(key)
          names.push({ key, name })
        }
      })

      return names
    },
    prepareToReopen () {
      this.tournament = null
      this.playerStatsNames = []
      this.teamStatsNames = []
    },
    refreshView () {

    }
  }
}
</script>
